import { render, staticRenderFns } from "./gBackTop.vue?vue&type=template&id=09250fe8&scoped=true&"
import script from "./gBackTop.vue?vue&type=script&lang=js&"
export * from "./gBackTop.vue?vue&type=script&lang=js&"
import style0 from "./gBackTop.vue?vue&type=style&index=0&id=09250fe8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09250fe8",
  null
  
)

export default component.exports